export enum SiNo {
  si = 1,
  no = 2
}

export default SiNo;